import Icon from '../components/Icon.vue'

Icon.register({"archive":{"width":512,"height":512,"paths":[{"d":"M32 448C32 465.7 46.3 480 64 480H448C465.7 480 480 465.7 480 448V160H32V448zM192 236C192 229.4 197.4 224 204 224H308C314.6 224 320 229.4 320 236V244C320 250.6 314.6 256 308 256H204C197.4 256 192 250.6 192 244V236zM480 32H32C14.3 32 0 46.3 0 64V112C0 120.8 7.2 128 16 128H496C504.8 128 512 120.8 512 112V64C512 46.3 497.7 32 480 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/archive.js
// module id = null
// module chunks = 